import { H2, L, Note, P, Ul } from '@/features/guide/prose'

export function SetupRestaurantVi() {
  return (
    <>
      <Note>
        Chỉ tài khoản <L k="role.manager" /> và <L k="role.superuser" /> mới mở được các trang này.
      </Note>
      <H2>Các loại tài khoản</H2>
      <Ul>
        <li>Khách hàng: không có vai trò; chỉ truy cập trang chủ và trang đặt món.</li>
        <li>
          <L k="role.staff" />: vận hành chi nhánh (hàng đợi, phiên bàn, chi tiết đơn, tạo đơn cho khách). Làm việc tại các chi nhánh được chọn.
        </li>
        <li>
          <L k="role.admin" />: thêm quyền cài đặt chi nhánh, thực đơn chi nhánh, thống kê, bàn và nhân viên của chi nhánh mình quản lý.
        </li>
        <li>
          <L k="role.manager" />: tất cả quyền trên với mọi chi nhánh, cộng thêm các trang nhà hàng bên dưới. Cấp được vai trò <L k="role.staff" /> và{' '}
          <L k="role.admin" />.
        </li>
        <li>
          <L k="role.superuser" />: chủ nhà hàng, tài khoản đã tạo nhà hàng. Cấp thêm được vai trò <L k="role.manager" />.
        </li>
      </Ul>
      <P>Một vai trò chỉ được cấp hoặc gỡ bởi người có vai trò cao hơn.</P>
      <H2>Mở trang quản lý nhà hàng</H2>
      <P>
        Truy cập romi.io.vn/url-nha-hang (thay “url-nha-hang” bằng Tên URL thực tế) và đăng nhập, hoặc đăng nhập rồi đi tới nhà hàng qua{' '}
        <L k="nav.myRestaurants" />. Ấn <L k="landing.manageRestaurant" />.
      </P>
      <P>
        Có 6 trang quản lý: <L k="nav.branches" />, <L k="nav.menu" />, <L k="nav.feedback" />, <L k="nav.accounts" />, <L k="nav.auditLog" /> và{' '}
        <L k="nav.settings" />.
      </P>
      <H2>Chi nhánh</H2>
      <P>
        Hiển thị các chi nhánh của nhà hàng; mở một chi nhánh để tới trang quản lý của nó. Cũng có thể thêm chi nhánh (<L k="restaurants.addBranch" />) hoặc
        ngừng một chi nhánh cũ (<L k="restaurants.deactivate" />). Chi nhánh đã ngừng chỉ còn xem được thống kê và có thể kích hoạt lại sau.
      </P>
      <H2>Thực đơn</H2>
      <P>Quản lý danh mục và các món trong thực đơn. Khách xem danh mục theo thứ tự ở đây; chuyển lên xuống khi cần.</P>
      <Ul>
        <li>
          Ấn <L k="menu.addCategory" /> và đặt tên (ngôn ngữ chính bắt buộc, ngôn ngữ khác không bắt buộc).
        </li>
        <li>
          Ấn <L k="menu.addItem" /> trong danh mục.
        </li>
        <li>Đặt tên món, chọn danh mục, điền giá (theo tiền tệ của chi nhánh; VND chỉ nhận số nguyên).</li>
        <li>
          <L k="menu.step" />: chọn <L k="menu.step.whole" /> cho món chỉ bán nguyên phần, <L k="menu.step.half" /> cho món có bán nửa phần như nửa con
          vịt/gà, chọn <L k="menu.step.tenth" /> cho món bán theo cân như tôm/cua cân lên được 1,7 kg. Giá luôn tính cho một phần nguyên.
        </li>
        <li>Tải ảnh món (không bắt buộc) và lưu.</li>
      </Ul>
      <H2>Góp ý</H2>
      <P>Hiển thị góp ý của khách hàng, từ đơn hàng và từ trang giới thiệu nhà hàng.</P>
      <H2>Tài khoản</H2>
      <P>
        Quản lý tất cả nhân sự của nhà hàng, như đặt một tài khoản làm <L k="role.manager" /> hoặc <L k="role.admin" />. Với <L k="role.staff" /> và{' '}
        <L k="role.admin" />, bạn chọn thêm các chi nhánh người đó làm việc.
      </P>
      <P>
        Để thêm nhân viên, trước tiên nhân viên cần tạo tài khoản Romi. Sau đó tìm tài khoản theo đúng số điện thoại hoặc email và ấn{' '}
        <L k="accounts.grant" />. Nhân viên cũng thêm được từ trang <L k="nav.staff" /> của chi nhánh.
      </P>
      <H2>Nhật ký thay đổi</H2>
      <P>Xem lại ai đã thay đổi gì khi cần.</P>
      <H2>Cài đặt</H2>
      <P>
        Đổi tên nhà hàng, màu hiển thị cho các nút và thanh điều hướng, ngôn ngữ hỗ trợ cho tên món, và lời giới thiệu hiển thị tại trang chủ nhà hàng. Tên URL
        không đổi được.
      </P>
      <Note>
        Khi có nhân viên nghỉ việc, ấn <L k="accounts.revoke" /> vai trò của người đó để họ không còn truy cập quản lý hay vận hành nhà hàng.
      </Note>
      <P>Chỉ còn một bước cài đặt chi nhánh nữa là bạn đã sẵn sàng.</P>
    </>
  )
}
